<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
    <div class="row">
      <div class="col-md-6">
        <base-input v-uppercase v-model="job.description" label="Description"></base-input>
      </div>
    </div>
    <base-button md type="primary" native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option, Form } from "element-ui";
export default {
   directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("job", ["job"]),
    ...mapGetters({
      jobList: "job/getJobList",
    }),
  },
  methods: {
    ...mapActions({
      saveJob: "job/saveJob",
      updateJob: "job/updateJob",
      getJobs: "job/getJobList"
    }),
    duplicateMessage() {
      const description = (this.job.description || "").trim().toLowerCase();
      if (!description) return "";
      const exists = (this.jobList || []).some(
        (row) =>
          row.jobId !== this.job.jobId &&
          (row.description || "").trim().toLowerCase() === description
      );
      return exists ? "This job already exists." : "";
    },
    notifySaveError(err) {
      const details =
        err && err.response && err.response.data && err.response.data.details;
      if (Array.isArray(details) && details.length) {
        details.forEach((item) => {
          this.$notify({
            message: item.message,
            type: "danger",
            title: "Validation Error",
          });
        });
        return;
      }
      this.$notify({
        message: "Could not save.",
        type: "danger",
        title: "Error",
      });
    },
    onSubmit() {
      const duplicate = this.duplicateMessage();
      if (duplicate) {
        this.$notify({
          message: duplicate,
          type: "danger",
          title: "Validation Error",
        });
        return;
      }
      if (this.job.jobId) {
        this.updateJob().then(res => {
          this.$notify({
            message: "Job Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getJobs();
          this.$emit("close");
        }).catch((err) => this.notifySaveError(err));
      } else {
        this.saveJob().then(res => {
          this.$notify({
            message: "Job Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getJobs();
          this.$emit("close");
        }).catch((err) => this.notifySaveError(err));
      }
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form
  }
};
</script>